<template>

  <ul class="list-none p-2 m-0">
    <li>
      <router-link to="/mod-stock/categories" v-ripple class="no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            <i class="pi pi-book mr-2"></i> 
            <span class="font-medium">KATEGÓRIE</span>
      </router-link>
      
    </li>
    
    <li>
      <router-link to="/mod-stock/colors" v-ripple class="no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            <i class="pi pi-slack mr-2"></i> 
            <span class="font-medium">FARBY</span>
      </router-link>
      
    </li>

    <li>
      <router-link to="/mod-stock/products" v-ripple class="no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            <i class="pi pi-th-large mr-2"></i> 
            <span class="font-medium">PRODUKTY</span>
      </router-link>
      
    </li>

    <li>
      <router-link to="/mod-stock/boxies" v-ripple class="no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            <i class="pi pi-box mr-2"></i> 
            <span class="font-medium">KRABICE</span>
      </router-link>
      
    </li>

    <li>
      <router-link to="/mod-stock/stock-items" v-ripple class="no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            <i class="pi pi-chart-pie mr-2"></i> 
            <span class="font-medium">KUSY</span>
      </router-link>
      
    </li>

    <li>
      <router-link to="/mod-stock/packages" v-ripple class="no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            <i class="pi pi-clone mr-2"></i> 
            <span class="font-medium">BALÍKY</span>
      </router-link>
      
    </li>

    <li>
      <router-link to="/mod-stock/search-items" v-ripple class="no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            <i class="pi pi-search-plus mr-2"></i> 
            <span class="font-medium">VYHĽADÁVANIE A REZERVÁCIA KUSOV</span>
      </router-link>
      
    </li>

    <li>
      <router-link to="/mod-stock/reservation-requests/1" v-ripple class="no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            <i class="pi pi-calendar-plus mr-2"></i> 
            <span class="font-medium">ŽIADOSTI O REZERVÁCIE</span>
      </router-link>
      
    </li>

    <li>
      <router-link to="/mod-stock/reservation-requests/2" v-ripple class="no-underline flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
            <i class="pi pi-calendar-plus mr-2"></i> 
            <span class="font-medium">ŽIADOSTI O PRESTRIEKANIE</span>
      </router-link>
      
    </li>

  </ul>


</template>

<script lang="ts">
import {store} from "@/components/store";
import Security from './security';

export default {
  name: "ManageStock",
  components:{
 
  },
  data() {
    return {
      store,
 
    }
  },

  beforeMount() {
    Security.requireToken()
    
  },
  //beforeUnmount() {
  //
  //},
  methods: {
  

  },

}
</script>
<style scoped>

</style>